'use client';

import apiService from '@/app/services/apiService';
import ProductCard from '../productCard';
import React, { useEffect, useState } from 'react';
import ShopFallbackPromo from "./ShopFallbackPromo";

export type ProductType = {
    id: string;
    name: string;
    price: number;
    image_url: string;
    imageAlt: string;
    currency: string;
    is_favorite: boolean;
}

interface ShopListProps {
    favorites?: boolean | null;
}

const ShopList: React.FC<ShopListProps> = ({
    favorites
}) => {

    const [products, setProducts] = useState<ProductType[]>([]);

    const markFavorite = (id: string, is_favorite: boolean) => {
        const tmpProducts = products.map((product: ProductType) => {
            if (product.id == id) {
                product.is_favorite = is_favorite

                if (is_favorite) {
                    console.log('added to list of favorited products')
                } else {
                    console.log('removed from list')
                }
            }

            return product;
        })

        setProducts(tmpProducts);
    }
        
    const getProducts = async () => {
        let url = '/api/shops/';

        if (favorites) {
            url  += '?is_favorites=true'
        } else {
            let urlQuery = '';

            if (urlQuery.length) {
                console.log('Query:', urlQuery);

                urlQuery = '?' + urlQuery.substring(1);

                url += urlQuery;
            }
        }

        const tmpProducts = await apiService.get(url);

        setProducts(tmpProducts.data.map((product: ProductType) => {
            if (tmpProducts.favorites.includes(product.id)) {
                product.is_favorite = true
            } else {
                product.is_favorite = false
            }
            return product
        }));
    };

    useEffect(() => {
        getProducts();
    }, []);

    if (products.length === 0) {
        return <ShopFallbackPromo />;
    }

    return (
        <section className="max-w-[1500px] mx-auto px-6 pb-6">
            <h2 className="my-6 mb-6 text-2xl">Ingressos</h2>
            
            <div className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8">
                {products.map((product: ProductType) => {
                    return (
                        <ProductCard 
                            key={product.id} 
                            product={product}
                            markFavorite={(is_favorite: any) => markFavorite(product.id, is_favorite)}
                        />
                    )
                })}
            </div>
        </section>
    )
    
}

export default ShopList;